<template>
  <notifications/>
  <router-view/>
  <CompanyDeactivatedModal />
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300..900;1,300..900&display=swap');

#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #495057;
}

nav a.router-link-exact-active {
  color: #22d3c5;
}
</style>

<script>
import {useRouter} from 'vue-router';
import store from './store';
import CompanyDeactivatedModal from '@/components/CompanyDeactivatedModal.vue';

export default {
  name: 'App',
  components: {
    CompanyDeactivatedModal,
  },

  mounted() {
    // 📡 Listeners globales Firebase
    window.addEventListener('chat:refresh', this.handleChatRefresh);
    window.addEventListener('chat:new-message', this.handleNewMessage);

    // 🖱️ Click notificación background
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', this.handleSWMessage);
    }
  },

  beforeUnmount() {
    window.removeEventListener('chat:refresh', this.handleChatRefresh);
    window.removeEventListener('chat:new-message', this.handleNewMessage);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.removeEventListener('message', this.handleSWMessage);
    }
  },

  methods: {
    // 🔄 CASO 1 — misma conversación (ya funciona)
    handleChatRefresh(event) {
      const sound = new Audio('/sounds/tono-mensaje.mp3');
      sound.play();
      window.dispatchEvent(new CustomEvent('chat:do-refresh', {
        detail: event.detail
      }));
    },

    // 📩 CASO 2 y 3 — foreground, conversación diferente o fuera de chat
    handleNewMessage(event) {
      const sound = new Audio('/sounds/tono-mensaje.mp3');
      sound.play();

      const {conversationId, payload} = event.detail;
      const data = payload?.data || {};
      const title = data.title || 'Nuevo mensaje';
      const body = data.body || '';

      // Re-emitir para el componente chat activo
      window.dispatchEvent(new CustomEvent('chat:do-new-message', {
        detail: event.detail
      }));

      // CASO 3 — estamos en /chat pero diferente conversación
      // CASO 2 — estamos en otra vista
      this.showInAppNotification({
        title,
        body,
        conversationId
      });
    },

    // 🖱️ CASO 4 — click en notificación del sistema (background/otra pestaña)
    handleSWMessage(event) {
      if (event.data?.type !== 'NAVIGATE') return;
      const sound = new Audio('/sounds/tono-mensaje.mp3');
      sound.play();
      const url = event.data.url;
      const urlObj = new URL(url);
      const conversationId = urlObj.searchParams.get('conversation');

      console.log('[SW → App] Navegando a:', url);

      if (conversationId) {
        this.$router.push({
          path: '/chat',
          query: {conversation: conversationId}
        }).catch(() => {
          // Ya estamos en /chat — forzar refresh
          window.dispatchEvent(new CustomEvent('chat:do-refresh', {
            detail: {conversationId}
          }));
        });
      }
    },


    // 🔔 Toast interno clicable con auto-cierre
    showInAppNotification({title, body, conversationId}) {
      // Usar vue3-notification
      this.$notify({
        title,
        text: `${body} — <strong>Click para abrir</strong>`,
        type: 'info',
        duration: 6000, // ← auto-oculta en 6 segundos
        data: {conversationId}
      });
    },
  }
};
</script>
